import { Check } from "lucide-react";
import { STATUS_ORDER, slug } from "@/lib/constants";
import { fmtDate } from "@/lib/api";

export const JobTimeline = ({ job }) => {
  const current = STATUS_ORDER.indexOf(job.status);
  const at = Object.fromEntries((job.status_history || []).map((h) => [h.status, h.at]));
  return (
    <div data-testid="job-tracking-timeline-container">
      <ol className="hidden md:grid grid-cols-10 gap-1">
        {STATUS_ORDER.map((s, i) => (
          <li key={s} data-testid={`job-timeline-step-${slug(s)}`} className="flex flex-col items-center text-center">
            <div className="flex items-center w-full">
              <div className={`h-0.5 flex-1 ${i === 0 ? "invisible" : i <= current ? "bg-[#F86900]" : "border-t border-dashed border-[#56585E]/40"}`} />
              <div className={`h-8 w-8 shrink-0 rounded-full flex items-center justify-center text-xs font-bold
                ${i < current ? "bg-[#020165] text-white" : i === current ? "bg-[#F86900] text-[#0D141A] am-pulse" : "bg-white border border-[#56585E]/30 text-[#56585E]"}`}>
                {i < current ? <Check className="h-4 w-4" /> : i + 1}
              </div>
              <div className={`h-0.5 flex-1 ${i === STATUS_ORDER.length - 1 ? "invisible" : i < current ? "bg-[#F86900]" : "border-t border-dashed border-[#56585E]/40"}`} />
            </div>
            <span className={`mt-2 text-[11px] leading-tight ${i === current ? "font-bold text-[#0D141A]" : "text-[#56585E]"}`}>{s}</span>
            {at[s] && <span className="text-[10px] text-[#56585E]/80">{fmtDate(at[s])}</span>}
          </li>
        ))}
      </ol>
      <ol className="md:hidden space-y-2">
        {STATUS_ORDER.map((s, i) => (
          <li key={s} data-testid={`job-timeline-mobile-step-${slug(s)}`}
            className={`flex items-center gap-3 rounded-lg px-3 py-2 ${i === current ? "bg-[#F86900]/10 border border-[#F86900]/40" : ""}`}>
            <div className={`h-6 w-6 rounded-full flex items-center justify-center text-[10px] font-bold
              ${i < current ? "bg-[#020165] text-white" : i === current ? "bg-[#F86900] text-[#0D141A]" : "border border-[#56585E]/30 text-[#56585E]"}`}>
              {i < current ? <Check className="h-3 w-3" /> : i + 1}
            </div>
            <span className={`text-sm ${i === current ? "font-bold" : i > current ? "text-[#56585E]" : ""}`}>{s}</span>
            {at[s] && <span className="ml-auto text-xs text-[#56585E]">{fmtDate(at[s])}</span>}
          </li>
        ))}
      </ol>
    </div>
  );
};
